module.exports = __webpack_public_path__ + "static/img/xiaoruanmeng.5577fab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/woman/banner/xiaoruanmeng.jpg
// module id = SQ6H
// module chunks = 0